import { render, staticRenderFns } from "./DoKoDialogRestrictions.vue?vue&type=template&id=049cb8ec&scoped=true&"
import script from "./DoKoDialogRestrictions.vue?vue&type=script&lang=ts&"
export * from "./DoKoDialogRestrictions.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDialogRestrictions.vue?vue&type=style&index=0&id=049cb8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049cb8ec",
  null
  
)

export default component.exports